import { render } from "./Footer.vue?vue&type=template&id=bab8fed2&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=bab8fed2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bab8fed2"

export default script